// extracted by mini-css-extract-plugin
export default {"breadCrumb":"styles_breadCrumb__xYgQq","customBtn":"styles_customBtn__U1wME","invertBtn":"styles_invertBtn__7x80B"};